// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"812":"04c87024","5304":"04c87024","9029":"04c87024","9175":"328fa00d"}[chunkId] + ".chunk.css";
};